<template>
    <main class="trends-page">
        <SliceZone :components="components" :slices="trends?.data?.slices ?? []" />
    </main>
</template>
<script setup lang="ts">
    import {SliceZone} from '@prismicio/vue';
    import type {TrendsDocument} from '@prismicio-types';
    import {useRoute} from '@typed-router';
    import {useAsyncData, useHead, useRequestURL, useSeoMeta, useWebsitePageView} from '#imports';
    import usePrismicDocument from '~/composables/content/usePrismicDocument';
    import {components} from '~/slices/components';

    const {
        params: {uid},
    } = useRoute('resources-trends-uid');

    const {data: trends} = await useAsyncData('trends', () => usePrismicDocument<TrendsDocument>('trends', uid as string), {deep: true});

    if (trends.value) {
        useSeoMeta({
            title: trends.value.data.metaTitle ?? '',
            description: trends.value.data.metaDescription ?? '',
            robots: trends.value.data.noIndex ? 'noindex' : 'index',
            ogImage: trends.value.data.openGraphImage?.url ?? '',
            ogTitle: trends.value.data.openGraphTitle ?? '',
            ogDescription: trends.value.data.openGraphDescription ?? '',
        });
    }

    const {origin, pathname} = useRequestURL();
    const canonicalUrl = `${origin}${pathname}`;
    useHead({link: [{rel: 'canonical', href: canonicalUrl}]});

    useWebsitePageView('resources-center', 'trends');
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .trends-page {
        .slice-title h2 {
            font-weight: 500;
            font-size: var(--joy-font-size-secondary-400);
            line-height: var(--joy-line-height-small);
            margin-bottom: var(--joy-core-spacing-8);

            @include mq.screen_md(min) {
                font-size: var(--joy-font-size-secondary-600);
            }
        }
        .slice-content {
            text-align: left;
            position: relative;
            max-width: calc(1180px + 2 * var(--joy-core-spacing-9));
        }
    }
</style>
